// Flow types automatically removed

import { createFragmentContainer, graphql } from 'react-relay/legacy';
import styles from './styles/InteriorsLandingModuleHeader.scss';
export function InteriorsLandingModuleHeaderComponent({ header, module }) {
    if (!header.title) {
        return null;
    }

    return (
        <div className="rowFlex">
            <div className={`colXs12 ${styles.wrapper}`}>
                <h2 className={styles.title} data-tn={`interiors-landing-${module}-header-title`}>
                    {header.title}
                </h2>
                {header.description && (
                    <div
                        className={styles.description}
                        data-tn={`interiors-landing-${module}-header-description`}
                    >
                        {header.description}
                    </div>
                )}
            </div>
        </div>
    );
}
export const InteriorsLandingModuleHeader = createFragmentContainer(
    InteriorsLandingModuleHeaderComponent,
    {
        header: graphql`
            fragment InteriorsLandingModuleHeader_header on InteriorsLandingHeadModule {
                description
                title
            }
        `,
    }
);
